import { arrayOf, exact, string } from "prop-types";

/** @deprecated use TypeScript interface or type instead */
export const availableParentType = exact({
  key: string.isRequired,
  items: arrayOf(
    exact({
      text: string.isRequired,
      value: string.isRequired,
      group: string.isRequired,
    })
  ),
});
